module.exports = __webpack_public_path__ + "img/22.92894fe3.jpg";